import { Document } from "@models";
import { DataKeyWithValue } from "@types";

export const mapDocumentVersionsToDataKeys = (
  documents: Document[]
): DataKeyWithValue[] => {
  return documents
    .map((doc) => {
      if (!doc.versions[0]) return [];

      return doc.versions[0].answers.map((answer) => ({
        id: answer.element,
        value: answer.answer,
      }));
    })
    .flat();
};
